function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9.85 19.72a9.86 9.86 0 119.86-9.86 9.86 9.86 0 01-9.86 9.86zM15.6 9.04a.83.83 0 00-.82-.82h-3.29V4.93a.83.83 0 00-.82-.82H9.03a.83.83 0 00-.82.82v3.31H4.92a.83.83 0 00-.82.82v1.64a.83.83 0 00.82.82h3.29v3.29a.83.83 0 00.82.82h1.63a.83.83 0 00.82-.82v-3.29h3.29a.83.83 0 00.82-.82V9.04z"
});

var SvgPlusCircle = function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 19.71 19.71"
  }, props), _ref);
};

export default SvgPlusCircle;